import { z } from "zod";

export const CART_QUANTITY_MIN = 1;
export const CART_QUANTITY_MAX = 99;

export const StorefrontCartItemSchema = z.object({
  id: z.string().min(1),
  menuItemId: z.string().min(1),
  variantId: z.string().uuid().nullable(),
  variantName: z.string().min(1).nullable(),
  name: z.string().min(1),
  quantity: z.number().int().min(CART_QUANTITY_MIN).max(CART_QUANTITY_MAX),
  unitPriceCents: z.number().int().min(0),
  lineTotalCents: z.number().int().min(0),
});

export const StorefrontCartSchema = z.object({
  restaurantId: z.string().min(1),
  items: z.array(StorefrontCartItemSchema),
  itemCount: z.number().int().min(0),
  subtotalCents: z.number().int().min(0),
});

export type StorefrontCartItem = z.infer<typeof StorefrontCartItemSchema>;
export type StorefrontCart = z.infer<typeof StorefrontCartSchema>;

export const AddCartItemBodySchema = z.object({
  menuItemId: z.string().uuid(),
  variantId: z.string().uuid().optional(),
  quantity: z.number().int().min(CART_QUANTITY_MIN).max(CART_QUANTITY_MAX).optional(),
  restaurantId: z.string().optional(),
});

export const UpdateCartItemBodySchema = z.object({
  quantity: z.number().int().min(0).max(CART_QUANTITY_MAX),
  restaurantId: z.string().optional(),
});

export type AddCartItemBody = z.infer<typeof AddCartItemBodySchema>;
export type UpdateCartItemBody = z.infer<typeof UpdateCartItemBodySchema>;
